import { Component, Host, h, Prop, Element } from '@stencil/core';
import { BoxColor } from './box-interface';
import { hasSlot } from '../../utils';

/**
 * @since 1.0
 * @status Stable
 *
 * @slot - Main content of the box.
 * @slot heading - Slot for heading with html tags.
 *
 * @part box - Main box container.
 * @part heading - Heading of the box.
 * @part content - Content.
 */
@Component({
  tag: 'o2-box',
  styleUrl: 'box.scss',
  shadow: true,
})
export class O2Box {
  private hasHeadingSlot: boolean;

  @Element() private el!: HTMLO2BoxElement;

  /**
   * Heading text of the box.
   */
  @Prop() heading?: string;

  /**
   * Type of box component.
   * Possible values: `"transparent"`, `"white"`, `"gray"`, `"blue-light"`, `"red-light"`, `"green-light"`, `"orange-light"`.
   */
  @Prop() background?: BoxColor = 'transparent';

  /**
   * Show/hide box border.
   */
  @Prop() border?: boolean = false;

  connectedCallback() {
    this.hasHeadingSlot = hasSlot(this.el, '[slot="heading"]');
  }

  render() {
    const headingContent = this.heading ? this.heading : <slot name="heading" />;
    return (
      <Host>
        <div part="box" class={`box box--${this.background} ${this.border ? 'box--border' : ''}`}>
          {this.heading || this.hasHeadingSlot ? (
            <h3 part="heading" class="box__heading">
              {headingContent}
            </h3>
          ) : (
            ''
          )}
          <div part="content" class="box__content">
            <slot></slot>
          </div>
        </div>
      </Host>
    );
  }
}
